import Layout from "@/components/layout";
import OperationsController from "@/modules/operations/OperationsController";
import AccessRestricted from "@/components/AccessRestricted";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

/**
 * Operations page, gated on the operations.view permission. Users without it
 * see an access denied message.
 */
export default function Operations() {
  const canViewOperations = useHasPermission(Permission.OPERATIONS_VIEW);

  if (!canViewOperations) {
    return (
      <AccessRestricted
        breadcrumbs={[
          { label: "Records" },
          { label: "Operations", current: true },
        ]}
      />
    );
  }

  return (
    <Layout breadcrumbs={[{ label: "Operations", current: true }]}>
      <OperationsController />
    </Layout>
  );
}
